const REALM = 'realm';
const ACCESS_TOKEN = 'xstak_studio_token';
const REFRESH_TOKEN = 'xstak_studio_refresh';
const storagePrefix = 'xstak_studio_';

export const getRealm = () => {
  let realm = '';
  try {
    realm = localStorage.getItem(REALM);
    realm = JSON.parse(realm);
  } catch (err) {}
  return realm;
};

export const getAccessToken = () => {
  let token;
  try {
    token = localStorage.getItem(ACCESS_TOKEN) || '';
    token = JSON.parse(token);
  } catch (err) {}
  return token;
};

export const getRefreshToken = () => {
  let token = '';
  try {
    token = localStorage.getItem(REFRESH_TOKEN);
    token = JSON.parse(token);
  } catch (err) {}
  return token;
};

export const setAccessToken = (token) => {
  localStorage.setItem(ACCESS_TOKEN, token);
};

export const setRefreshToken = (token) => {
  localStorage.setItem(REFRESH_TOKEN, token);
};
export const clearStorage = () => {
  localStorage.clear();
};
export const getUserPermissions = () => {
  return JSON.parse(window.localStorage.getItem('apps'));
};
const storage = {
  setRemember: (rememberState) => {
    window.localStorage.setItem(`${storagePrefix}remember`, JSON.stringify(rememberState));
  },
  setApps: (apps) => {
    window.localStorage.setItem(`apps`, JSON.stringify(apps));
  },
  getApps: () => {
    return JSON.parse(window.localStorage.getItem('apps'));
  },
  getRemember: () => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}remember`));
  },
};
export default storage;
